<template>
  <router-link :to="{ path: routerPath, query: queryObject }">
    <span :class="'link'" v-if="uiConfigBool" >
      <b-icon :icon="iconNameDefault" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover :title="modifyTooltipText($t(tooltipText))"/>
      <b-icon :icon="iconNameOnHover" :class="'mb-0 ' + sizeClass" v-b-tooltip.hover :title="modifyTooltipText($t(tooltipText))"/>
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'IconActionButton',
  props: {
    routerPath: {
      type: String,
      required: true
    },
    queryObject: {
      type: Object,
      required: true
    },
    uiConfigBool: {
      type: Boolean,
      required: true
    },
    iconNameDefault: {
      type: String,
      required: true
    },
    iconNameOnHover: {
      type: String,
      required: true
    },
    tooltipText: {
        type: String,
        required: true
    },
    sourceId: {
      type: String,
      required: true,
    },
    sizeClass: {
      type: String,
      default: 'h5'
    }
  },
  methods: {
    modifyTooltipText(text) {
      return `${text} (${this.$t('system_event.sourceId')}: ${this.sourceId})`;
    }
  }
};
</script>

<style scoped>
  .link {
    color: green;
  }
  .link.disabled {
      color: grey;
  }

  .link svg:nth-child(2) {
    display: none; 
  }

  .link:hover svg:nth-child(2) {
    display: inline;
  }

  .link:hover svg:nth-child(1) {
    display: none;
  }

  .link.disabled svg:nth-child(1) {
      display: inline;
  }
  .link.disabled svg:nth-child(2) {
      display: none;
  }
</style>